<template>
  <router-link 
      :style="{ textDecoration: 'none' }" 
      :key="post.id"
      :to="{ name: 'blogpost', params: { slug: post.slug } }"
    >

    <div class="blog-item__header">
      <img 
        :src="post.featured_image_src.full[0]" 
        :alt="`Read blog post ${post.title.rendered}`" 
        v-if="post.featured_image_src.full[0]"
      />
      <i v-else class="fas"></i>
      <router-link 
        :style="{ textDecoration: 'none' }"
        :to="{ name: 'blogcategory', params: { slug: post.cat_name[0].slug } }"
      >
        <cmscontent :content="post.cat_name[0].name" class="blog-item__category"/>
      </router-link>
    </div>

    <div class="blog-item__content">
      <cmscontent :content="formatDate(post.date)"/>
      <cmscontent :content="`<h3>${post.title.rendered}</h3>`"/>
      <cmscontent :content="post.excerpt.rendered"/>
    </div>

    <button class="blog-item__btn">Read more</button>
  </router-link>
</template>

<script>

export default {

  data() {
    return {
      classNames: [
        { class: 'fa-lemon', color: '#D8EF21' },
        { class: 'fa-pepper-hot', color: '#DE2121' },
        { class: 'fa-seedling', color: '#157740' },
        { class: 'fa-apple-alt', color: '#21DE73' }
      ],
    }
  },

  mounted() {
    this.shuffle(); 
  },

  props: {
    post: Object
  },

  computed: {
    posts() {
      return this.$store.state.posts;
    }
  },

  methods: {
    formatDate() {
      let options = { 
        day: 'numeric', 
        year: 'numeric', 
        month: 'long' 
      }

      let postDate = new Date(this.post.date);

      return postDate.toLocaleDateString('en-US', options);
    },
    
    shuffle() {
      let icons = document.querySelectorAll('.fas');

      icons.forEach(icon => {

        let index = Math.floor(Math.random() * (this.classNames.length));

        while (icon.classList.length <= 1) {
          icon.classList.add(this.classNames[index].class);
          icon.style.backgroundColor = this.classNames[index].color;
        }
         
        
      });

    }, 


  }

}
</script>

<style lang="scss">
@import './style.scss';


</style>